import api from '../api/client';

export const fretesService = {
  salvar: (organizadorId, dados) =>
    api.post(`/organizadores/${organizadorId}/fretes`, dados),

  listar: (organizadorId, filtros = {}) =>
    api.get(`/organizadores/${organizadorId}/fretes`, { params: filtros }),

  getPdf: (organizadorId, filtros = {}) =>
    api.get(`/organizadores/${organizadorId}/fretes/pdf`, {
      params: filtros,
      responseType: 'blob',
    }),
};

